import { Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

import { DonationWrapper } from '../Charity/DonationOptions/style';

const SecondaryModalBody = styled.div`
  display: flex;
  gap: 24px;
  margin-top: 24px;
`;

const ImageColumn = styled.div`
  flex: 0.4;
`;

const DescriptionColumn = styled.div`
  flex: 0.6;
`;

const ProductImageWrapper = styled.div`
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  object-fit: contain;
`;

const ProductDesc = styled.div`
  margin-bottom: 16px;
  margin-top: 16px;
  overflow-y: auto;

  .show-more {
    margin-bottom: 8px;
  }

  .product-desc,
  .product-desc ul,
  .product-desc ul li {
    color: var(--color-neutral-800);
    font-size: 16px;
    font-style: normal;
    font-weight: normal;
    line-height: 24px;
  }

  .product-desc ul,
  .product-desc ul li {
    list-style-type: disc;
    margin: 0 0 0 10px;
  }
`;

const SkuListWrapper = styled.ul`
  border-top: 1px solid var(--color-accent-secondary-weaker);
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 16px;
  max-height: 250px;
  padding-top: 16px;

  ${DonationWrapper} {
    margin-bottom: 24px;
  }
`;

const FooterText = styled(Typography)`
  display: flex;
  gap: 4px;
`;

export {
  DescriptionColumn,
  FooterText,
  ImageColumn,
  ProductDesc,
  ProductImageWrapper,
  SecondaryModalBody,
  SkuListWrapper
};
